import PartnerIntegration from "domain/partnerIntegration";

export default class BidIntegration extends PartnerIntegration {
    isEnabled: boolean;
    bidConfiguration?: any;
}